import { Http } from '@/model/Http.js'
import { getToken, getUserUUID, removeToken, removeUserInfo } from '@/utils/auth'
export default class home extends Http {
  //首页-本月新增、15天订单数
  getStatisticsData(data){
    const url = 'api/platform-stat/search'
    return this.postAjax(url, {
      ...data
       // ...param
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/home.js